module.exports = __webpack_public_path__ + "static/img/luchi.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stars/luchi.jpg
// module id = t+Nk
// module chunks = 0